/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import useEnterpriseMegaMenuLinks from 'bundles/composable-page-header-enterprise/hooks/useEnterpriseMegaMenuLinks';
import SimplifiedMegaMenuWrapper from 'bundles/megamenu/components/SimplifiedMegaMenuWrapper';
import MegaMenuLinksProvider from 'bundles/megamenu/providers/MegaMenuLinksProvider';

const styles = {
  exploreButtonHeaderSpacing: css`
    margin-left: var(--cds-spacing-100);
    margin-right: calc(var(--cds-spacing-50) * -1);
  `,
};

const ExploreMegaMenuGridItem = () => {
  const links = useEnterpriseMegaMenuLinks();

  return (
    <MegaMenuLinksProvider links={links} isEnterprise>
      <div className="rc-ExploreMegaMenuGridItem" css={styles.exploreButtonHeaderSpacing}>
        <SimplifiedMegaMenuWrapper />
      </div>
    </MegaMenuLinksProvider>
  );
};

export default ExploreMegaMenuGridItem;
